import e from "./_baseCreate.js";
import t from "./isObject.js";
function r(r, o, p, a, n) {
  if (!(a instanceof o)) return r.apply(p, n);
  var f = e(r.prototype),
    i = r.apply(f, n);
  return t(i) ? i : f;
}
export { r as default };